import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchProcessSteps } from "#modules/quoteRequests/infra/fetchQuoteRequestProcessSteps.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const quoteRequestProcessStepsQuery = (id: string | undefined) => ({
  queryKey: queryKeys.quoteRequests.processSteps(id),
  queryFn: () => fetchProcessSteps(id!),
  staleTime: STALE_TIME,
  enabled: !!id,
});
